var EnablementMode = /* @__PURE__ */ ((EnablementMode2) => {
  EnablementMode2["Enabled"] = "Enabled";
  EnablementMode2["Disabled"] = "Disabled";
  EnablementMode2["Null"] = "Null";
  return EnablementMode2;
})(EnablementMode || {});
export {
  EnablementMode
};
//# sourceMappingURL=enablementMode.js.map
